module.exports = __webpack_public_path__ + "static/media/26-iveco-mercedes.26179046.jpg";